// Button.jsx
import React from "react";
import clsx from "clsx";

const Button = ({ children, onClick, className = "", variant = "default", ...props }) => {
  const baseStyles = "inline-flex items-center px-4 py-2 rounded-xl transition text-sm font-medium focus:outline-none";

  const variants = {
    default: "bg-cta text-white hover:bg-cta/90",
    ghost: "bg-transparent text-body hover:bg-accent-1/10",
    surface: "bg-surface text-body hover:bg-accent-1/10 border border-border",
  };

  return (
    <button
      onClick={onClick}
      className={clsx(baseStyles, variants[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
